import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { MarkdownComponent } from '../../../Components/Markdown';

interface AnswerCardProps {
  answer: string;
  'data-testid'?: string;
}

const AnswerCard: React.FC<AnswerCardProps> = ({ answer, 'data-testid': testId }) => {
  return (
    <Paper sx={{ p: 3, mb: 3 }} data-testid={testId}>
      <Typography variant="h3" sx={{ mb: 2 }}>
        Answer
      </Typography>
      <Box sx={{ bgcolor: '#F8F8F8', p: 2, borderRadius: 1 }}>
        <MarkdownComponent>{answer}</MarkdownComponent>
      </Box>
    </Paper>
  );
};

export default AnswerCard;
